export default __webpack_public_path__ + "static/mobile-banner-640a4adedf0c1ede602d738c07c3f8a9.png";